import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AccessDenied from "../components/AccessDenied";

/**
 * Template §9. Wraps a route element and checks access via a predicate from utils/access.
 *
 * Redirects to the dashboard, never to /login — the user IS authenticated, just not authorized, and
 * sending them to a login form they have already passed is confusing and loops if they re-authenticate
 * as the same account.
 *
 * LEGAL PHASE 2 §31 — `deniedAs="page"` is an OPT-IN: that route explains the refusal ("Access
 * denied") instead of silently moving the reader to the dashboard. Every route that does not opt in
 * keeps the redirect it always had, so no other department's behaviour changes. Either way this is
 * presentation — the server refuses the data regardless.
 */
export default function RoleRoute({ check, children, deniedAs, deniedMessage }) {
  const { user } = useAuth();
  if (!check(user)) {
    // P5 — `deniedMessage` lets a non-Legal route say what it actually is; omitted, the Legal wording
    // every existing opt-in route shows is unchanged.
    return deniedAs === "page"
      ? (deniedMessage ? <AccessDenied message={deniedMessage} /> : <AccessDenied />)
      : <Navigate to="/" replace />;
  }
  return children;
}
